<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <div class="app__content message">
    <div class="message__header">
      <div class="message__image">
        <img
          *ngIf="whitelabelIcon"
          [src]="whitelabelIcon"
          appImgFallback
          width="40"
          height="40"
          alt="{{ whitelabelName }}"
        />
      </div>
      <div class="message__info">
        <h1>{{ whitelabelName }}</h1>
        <span>{{ message.createdAt | date:'longDate' }}</span>
      </div>
      <div
        tabindex="0"
        role="button"
        class="message__share"
        (click)="share()"
        *ngIf="canShare"
      >
        <span [inlineSVG]="'/assets/icons/card/share.svg'"></span>
      </div>
    </div>

    <div class="message__content">
      <h2>{{ message.title ? message.title : message.titleText }}</h2>
      <div [innerHTML]="message.contentText"></div>
    </div>
  </div>
</ion-content>
